var map = {
	"./anestesia.png": 306,
	"./avi2.png": 1006,
	"./despacho.png": 238,
	"./gabinete.png": 307,
	"./icon_green.png": 1007,
	"./icon_red.png": 1008,
	"./icon_sage.png": 1009,
	"./icon_yellow.png": 1010,
	"./jpg2.png": 1011,
	"./logo.png": 1012,
	"./logo_2.png": 1013,
	"./logo_alaquas.png": 434,
	"./logo_massanassa.png": 435,
	"./pdf2.png": 1014,
	"./png2.png": 1015,
	"./sala_espera.png": 308,
	"./txt2.png": 1016,
	"./xls2.png": 1017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1005;